var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 7.00003C0.5 6.80112 0.579018 6.61035 0.71967 6.4697C0.860322 6.32905 1.05109 6.25003 1.25 6.25003H18.9395L14.219 1.53103C14.0782 1.3902 13.9991 1.19919 13.9991 1.00003C13.9991 0.800866 14.0782 0.609859 14.219 0.469029C14.3598 0.328199 14.5508 0.249083 14.75 0.249083C14.9492 0.249083 15.1402 0.328199 15.281 0.469029L21.281 6.46903C21.3508 6.5387 21.4063 6.62146 21.4441 6.71258C21.4819 6.8037 21.5013 6.90138 21.5013 7.00003C21.5013 7.09868 21.4819 7.19636 21.4441 7.28748C21.4063 7.3786 21.3508 7.46136 21.281 7.53103L15.281 13.531C15.1402 13.6719 14.9492 13.751 14.75 13.751C14.5508 13.751 14.3598 13.6719 14.219 13.531C14.0782 13.3902 13.9991 13.1992 13.9991 13C13.9991 12.8009 14.0782 12.6099 14.219 12.469L18.9395 7.75003H1.25C1.05109 7.75003 0.860322 7.67101 0.71967 7.53036C0.579018 7.38971 0.5 7.19894 0.5 7.00003Z",
    fill: "#2697FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.e0091956.svg";
export { ForwardRef as ReactComponent };